export const OTHER_RELIGION = 17;
export const CIVIL_STAT_MARRIED = 19;
export const DATE_FORMAT = 'YYYY-MM-DD';
export const OTHER_OWNERSHIP_TYPE = 50;
export const TENANT_OWNERSHIP_TYPE = 48;
export const LEASE_OWNERSHIP_TYPE = 49;
export const OTHER_OWNERSHIP_DOC = 63;